import type { Payment, QuoteDocument } from 'paintscout'
import { getPayments } from './get-payments'

/**
 * Returns whether a payment is a request with a child payment that is currently processing.
 */
export function requestHasProcessingPayment(args: { quote: QuoteDocument; payment: Payment }): boolean {
  const { quote, payment } = args
  // a request is a pending payment with an id; its children reference it via paymentRequestId
  if (!payment.id || payment.status !== 'pending') return false
  return getPayments({ quote }).some((p) => p.paymentRequestId === payment.id && p.status === 'processing')
}
